import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedLayout from "./components/plantilla/mainLayout/ProtectedLayout";

// PAGINAS
import Dashboard from './pages/dashboard/Dashboard';
import UnidadesDetenidas from './pages/unidades_detenidas/UnidadesDetenidas';
import ConfigCorreos from './pages/config_correos/ConfigCorreos';
import CatalogoIncidencias from './pages/catalogo_incidencias/CatalogoIncidencias';
import MainIdleEvents from './pages/idle/MainIdleEvents';
import IdleUserConfig from './pages/idle_user_config/IdleUserConfig';
import Hos from "./pages/safety_hos/Hos";
import LogIncidents from "./pages/log_incidents/LogIncidents";
import Routes_Monit from "./pages/routes_monit/RoutesMonit";


function App() {

  return (

    <Router>

      <Routes>

        {/* DASHBOARD */}
        <Route 
          path="/" 
          element={
            <ProtectedLayout>
              <Dashboard />
            </ProtectedLayout>
          } 
        />
        {/* UNIDADES DETENIDAS */}
        <Route 
          path="/unidades_detenidas" 
          element={
            <ProtectedLayout> 
              <UnidadesDetenidas /> 
            </ProtectedLayout>
          } 
        />
        {/* CONFIGURACION DE CORREOS */}
        <Route 
          path="/config_correos" 
          element={
            <ProtectedLayout> 
              <ConfigCorreos /> 
            </ProtectedLayout>
          } 
        />
        {/* CATALOGO DE INCIDENTES */}
        <Route 
          path="/catalogo_incidencias" 
          element={
            <ProtectedLayout> 
              <CatalogoIncidencias /> 
            </ProtectedLayout>
          }
        />
        {/* IDLE */}
        <Route 
          path="/idle_events" 
          element={
            <ProtectedLayout> 
              <MainIdleEvents /> 
            </ProtectedLayout>
          }
        />
        {/* IDLE */}
        <Route 
          path="/idle_user_config" 
          element={
            <ProtectedLayout> 
              <IdleUserConfig /> 
            </ProtectedLayout>
          }
        />
        {/* SAFETY HOS */}
        <Route 
          path="/hos" 
          element={
            <ProtectedLayout> 
              <Hos /> 
            </ProtectedLayout>
          }
        />
        {/* log_incidents */}
        <Route 
          path="/log_incidents" 
          element={
            <ProtectedLayout> 
              <LogIncidents /> 
            </ProtectedLayout>
          }
        />

        {/* RUTAS */}
        <Route 
          path="/rutas" 
          element={
            <ProtectedLayout> 
              <Routes_Monit /> 
            </ProtectedLayout>
          }
        />

      </Routes>

    </Router>

  );

}

export default App;
